class DataStore {
    private dataStore: { [key: string]: string } = {};

    public putData(key: string, value: string) {
        this.dataStore[key] = value;
    }

    public clear() {
        this.dataStore = {};
    }

    getData(key: string): string {
        return this.dataStore[key] ?? '';
    }
}

const dataStore = new DataStore();
export default dataStore;
